module.exports = __webpack_public_path__ + "img/konto.f487f4bd.svg";